// extracted by mini-css-extract-plugin
export default {"notFoundOuterBox":"NotFound_notFoundOuterBox__o+d8m","notFoundIcon":"NotFound_notFoundIcon__KZO5h","notFoundTypography":"NotFound_notFoundTypography__1h6lz"};